/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Rich_Otter_DineInputs */

const en_fresh_rich_otter_dine = /** @type {(inputs: Fresh_Rich_Otter_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

const de_fresh_rich_otter_dine = /** @type {(inputs: Fresh_Rich_Otter_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Fresh_Rich_Otter_DineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_rich_otter_dine = /** @type {((inputs?: Fresh_Rich_Otter_DineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Rich_Otter_DineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_rich_otter_dine(inputs)
	return de_fresh_rich_otter_dine(inputs)
});